import React, { Component } from "react";
import { connect } from "react-redux";
import Layout from "../../wrapper";
import { FormControl, Grid, InputLabel } from "@mui/material";
import axios from "axios";
import Loader from "../../Layout/Loader";
import TextField from "../../Components/common/TextField";
import Table from "../../Components/common/tableWithBackEndPagination";
import withRoutes from "../../HOC/HocRoutes";
import MenuItem from "../../Components/common/MenuItem";
import Button from "../../Components/common/Button";
import instance from "../../axios";
import { logInUserInfo } from "../../Actions/Users";
import { toast } from "react-toastify";
import ConfirmDialoag from "../../Components/common/ConfirmDialoag";

let source;
const entityOptions = [
  { name: "Vehicle", value: "vehicle" },
  { name: "Service", value: "service" },
  { name: "Account", value: "account" },
];

const serverOptions = [
  { name: "Dex", value: "dex" },
  { name: "Mac", value: "mac" },
];

class UnsyncedItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 20,
      searchInvoiceText: "",
      invoiceData: {},
      loaderContracts: false,
      entity: "",
      serverName: '',
      selectedRow:null
    };

    this.invoiceSource = axios.CancelToken.source();
  }

  componentDidMount() {
    this.getContractsData();
  }

  handleDropdownChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };
  getContractsData = () => {
    const { page, pageSize, searchInvoiceText, entity, serverName } = this.state;

    const params = new URLSearchParams();

    params.append("page", page);
    params.append("limit", pageSize);

    if (searchInvoiceText) {
      params.append("search", searchInvoiceText);
    }

    if (entity) {
      params.append("entity", entity);
    }

    if (serverName) {
      params.append("serverName", serverName);
    }

    const apiUrl = `/api/integrationlogs/get?${params.toString()}`;
    source = axios.CancelToken.source();

    this.setState({ loaderContracts: true });

    instance
      .get(apiUrl, { cancelToken: source.token })
      .then((res) => {
        this.setState({
          invoiceData: res || {},
          loaderContracts: false,
        });
      })
      .catch((e) => {
        if (e?.statusCode === "440") {
          this.props?.navigate("/logout")
        }
        this.setState({ loaderContracts: false });
      });
  };

  searchInvoiceText = (e) => {
    this.setState(
      {
        searchInvoiceText: e.target.value,
      }
    );
  };


  handleChangeRowsPerPage = (value) => {
    this.setState(
      {
        page: 1,
        pageSize: value,
      },
      () => {
        this.getContractsData();
      }
    );
  };

  handleChangePage = (value) => {
    this.setState(
      {
        page: value,
      },
      () => {
        this.getContractsData();
      }
    );
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  setPagination = () => {
    let nAcc;
    nAcc = { ...this.state.invoiceData };
    let lastPage = nAcc.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nAcc.data;
    nAcc.pageSize = this.state.pageSize;
    nAcc.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nAcc;
  };



  handleChange = (name, e) => {
    this.setState({
      [name]: e.target.value,
    });
  }
  handleSearch = () => {
    this.setState(
      {
        page: 1,
      },
      () => {
        this.getContractsData();
      }
    );
  };

  handleReset = () => {
    this.setState({
      searchInvoiceText: "",
      entity: "",
      page: 1,
      serverName: ""
    },()=>{
      this.getContractsData()
    });
  };

  getRowDefinition = () => {
    const { translate } = this.props;
    return [
      { id: "entity", label: translate("entity") },
      { id: "entityId", label: translate("entityId") },
      { id: "serverName", label: translate("serverName") },
      { id: "created", label: translate("created") },
      { id: "attempts", label: translate("attempts") },
      { id: "reason", label: translate("reason") },
    ];
  };

  handleResend = (item) => {
    this.setState({
      isResend: true,
      selectedRow: item,
    });
  };
  onCancelResend=()=>{
        this.setState({
      isResend: false,
      selectedRow: null,
    });
  }

  submitResend = () => {
    const { selectedRow } = this.state;
    const url = `/api/integrationlogs/resend/${selectedRow?.id}`;
    instance
      .get(url)
      .then((res) => {
        this.setState(
          { isResend: false, selectedRow: null },
          () => {
            this.getContractsData();
          }
        );

        toast.success(this.props.translate("entityResend"));
      })
      .catch((err) => {
        if (err?.response?.status === 440) {
          this.props.navigate("/logout");
        }

        toast.error(this.props.translate("somethingWentWrong"));
      });
  };
  render() {
    const { logInUser, translate, themecolors } = this.props;
    const { invoiceData, loaderContracts } = this.state;

    if (!logInUser) {
      fetch(
        "/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05",
        {
          headers: { Accept: "application/json; odata=verbose" },
        }
      )
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                let userInfo = res.data;
                this.props.setActiveLanguage(
                  userInfo?.attributes?.lang || "en"
                );
                this.props.dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");

                toast.error(this.props.translate(err[1]));
                this.props.navigate("/login");
              }
            });
          } else {
            this.props.navigate("/login");
            throw response;
          }
        })
        .catch((e) => {
          toast.error("somethingWentWrong");
        });
      return null;
    };

    return (
      <Layout {...this.props} {...this.state}>
        <Grid container alignItems="center">
          <Grid item xs={3}>
            <h4>{translate("unsyncedItems")}</h4>
          </Grid>
          <Grid
            item
            xs={9}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 2
            }}
          >
            <TextField
              label={translate("search")}
              value={this.state.searchInvoiceText}
              onChange={this.searchInvoiceText}
              sx={{ width: 220 }}
            />
            <TextField
              select
              label={this.props.translate("entity")}
              value={this.state.entity || ""}
              onChange={(e) => this.handleChange("entity", e)}
              sx={{ width: 180 }}
            >
              {entityOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {this.props.translate(option.name)}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              label={this.props.translate("serverName")}
              value={this.state.serverName || ""}
              onChange={(e) => this.handleChange("serverName", e)}
              sx={{ width: 180 }}
            >
              {serverOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {this.props.translate(option.name)}
                </MenuItem>
              ))}
            </TextField>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSearch}
            >
              {translate("search")}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
             disabled={
    !this.state.entity && !this.state.serverName && !this.state.searchInvoiceText
  }
              onClick={this.handleReset}
            >
              {translate("reset")}
            </Button>

          </Grid>

        </Grid>

        {loaderContracts ? (
          <Loader />
        ) : (
          <Table
            rows={invoiceData?.data || []}
            pagination={this.setPagination()}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleChangePage={this.handleChangePage}
            rowDefinition={this.getRowDefinition()}
            isEditable
            isSystem
            handleResend={this.handleResend}
            themecolors={themecolors}
            filterDropdown
            isCursoPointer
          />
        )}
        {this.state.isResend && (
          <ConfirmDialoag
            onCancel={this.onCancelResend}
            onOk={this.submitResend}
            title={this.props.translate("areYouWantToResend")}
            children={this.state.selectedRow?.entity || this.state.selectedRow?.entityId}
          />
        )}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  accounts: state.accounts,
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
});

export default connect(mapStateToProps)(withRoutes(UnsyncedItems));